<template>
  <NearMe :location="defaultLocation"/>
</template>
<script setup>
const props = defineProps({
  blok: Object,
});
const defaultLocation = 'Popular';
</script>
